module.exports = __webpack_public_path__ + "static/media/kit-ganado.636eff28.png";